// extracted by mini-css-extract-plugin
export default {"Pagination":"index__Pagination__YUViy","TableHead":"index__TableHead__U89ow","Tabs":"index__Tabs__aO28o","ExportAction":"index__ExportAction__dBpII"};